import {Alert, Box, Button, Grid, Icon, LinearProgress} from "@mui/material";
import {useDialog} from "muibox";
import {useNavigate} from "react-router-dom";
import {
    useArquivarProcessadasComErro,
    useOcorrenciasPaginado
} from "../../api/DpgeIntegracaoEsfingeApi";
import DataPanel from "../../components/data/DataPanel";
import FiltroEstados from "../../components/estado/FiltroEstados";
import Page from "../../components/layout/page/Page";
import PainelOcorrencias from "../../components/ocorrencia/PainelOcorrencias";
import PageHeader from "../../components/page-header/PageHeader";

import {
    useListQueryParam,
    useNumericQueryParam,
    useQueryParam,
    useSetParam
} from "../../shared/useQueryParam";
import Busca from "./Busca";
import Paginacao from "./Paginacao";

function EventosPage() {
    const page = useNumericQueryParam("page");
    const estados = useListQueryParam("estados");
    const expressao = useQueryParam("expressao") || "";
    const tipo = useListQueryParam("tipo");
    const incluirArquivados = useQueryParam("incluirArquivados") || false;
    const destinoEntrega = useQueryParam("destinoEntrega") || "";
    const navigate = useNavigate();
    const setParam = useSetParam();
    const dialog = useDialog();
    const arquivarProcessadasComErro = useArquivarProcessadasComErro();

    const filtrado =
        estados?.length || tipo?.length || expressao || destinoEntrega;
    const estadosAjustado = [...estados];

    const {
        data: ocorrenciaPage = {},
        isLoading,
        isFetching
    } = useOcorrenciasPaginado(
        page,
        estadosAjustado,
        expressao,
        tipo,
        incluirArquivados,
        destinoEntrega
    );
    const {pagina = {}, contagemEstado = []} = ocorrenciaPage;
    const {content: ocorrencias} = pagina;

    if ((pagina.totalPages > 0 && page >= pagina.totalPages) || page < 0) {
        navigate(`/?${setParam("page", 0)}`);
    }

    async function handleArquivarProcessadasComErro() {
        try {
            await dialog.confirm({
                title: "Deseja arquivar todas as ocorrências processadas com erro?",
                message:
                    "As ocorrências arquivadas deixarão de aparecer na listagem padrão, mas poderão ser consultadas pela opção Incluir arquivados.",
                ok: {text: "ARQUIVAR", color: "primary"},
                cancel: {text: "CANCELAR", color: "primary"}
            });
        } catch (error) {
            return;
        }

        arquivarProcessadasComErro.mutate();
    }

    return (
        <Page>
            <PageHeader
                primary="Ocorrências"
                secondary="Nesta página é possível visualizar as ocorrências registradas e acompanhar cada etapa do processamento"
                commands={[
                    <Button
                        key="arquivar-erros"
                        variant="outlined"
                        color="error"
                        startIcon={<Icon>archive</Icon>}
                        disabled={arquivarProcessadasComErro.isLoading}
                        onClick={handleArquivarProcessadasComErro}
                    >
                        {arquivarProcessadasComErro.isLoading
                            ? "Arquivando..."
                            : "Arquivar erros"}
                    </Button>
                ]}
            />
            <Busca />
            <FiltroEstados contagemEstado={contagemEstado} />
            <Box sx={{height: 4, mb: 1}}>
                {isFetching && (
                    <LinearProgress aria-label="Atualizando ocorrências" />
                )}
            </Box>
            <Box
                component="section"
                aria-label="Resultados das ocorrências"
                aria-busy={isFetching}
            >
                {!isLoading && (
                    <DataPanel
                        isEmpty={pagina.empty}
                        emptyMessage={
                            filtrado
                                ? "Nenhum evento com os filtros selecionados"
                                : "Nenhuma ocorrência registrada no conector"
                        }
                        paperEmptyPanel
                    >
                        <Grid container justifyContent="space-between">
                            <Grid item></Grid>
                            <Paginacao
                                pagina={pagina}
                                page={page}
                                expressao={expressao}
                            />
                        </Grid>

                        <Alert severity="info" sx={{mb: 2}}>
                            Lista por criação, mais recentes primeiro. O consumo
                            segue as dependências. “Em andamento” inclui espera
                            e reserva; “Etapa concluída” pode indicar apenas
                            recebimento pelo fornecedor. Confira a situação de
                            cada ocorrência para o aceite do TCE-MS.
                        </Alert>
                        <PainelOcorrencias ocorrencias={ocorrencias} />

                        <Grid container justifyContent="space-between">
                            <Grid item></Grid>
                            <Grid item></Grid>
                            <Paginacao pagina={pagina} page={page} />
                        </Grid>
                    </DataPanel>
                )}
            </Box>
        </Page>
    );
}

export default EventosPage;
